var _excluded = ["children", "items"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./dropdown-menu";
export function Dropdown(props) {
  var children = props.children,
    items = props.items,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownMenuTrigger, {
    className: "outline-none"
  }, children), /*#__PURE__*/React.createElement(DropdownMenuContent, _extends({
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, other), /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: i,
      disabled: item.disabled,
      onSelect: function onSelect(e) {
        return item.onClick(e);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row items-center cursor-pointer"
    }, item.icon, /*#__PURE__*/React.createElement("span", {
      className: "ml-2 text-md font-normal text-gray-900 dark:text-foreground"
    }, item.label)));
  }))));
}